"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.states = void 0;
exports.states = {
    routing: '@states/routing',
    noResults: '@states/noResults',
    unexpandable: '@states/unexpandable',
    expandable: '@states/expandable',
    contracted: '@states/contracted',
    expanded: '@states/expanded',
    searching: '@states/searching'
};
//# sourceMappingURL=states.js.map